import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft } from "react-feather";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { sampleEmployeeData, sampleTimelogData } from "core/json/sample_data";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";

import { all_routes } from "Router/all_routes";
import * as Yup from "yup";
import { Table, DatePicker, Select } from "antd";
import { toast } from "core/Operations/toast";
import { useImportEmployeesMutation } from "AppQuries/employee/import-employee";
import { importTimelogValidationSchema } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import {
  useFormattedEmployees,
  useFormattedExcluedEmployeesOptions,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import dayjs from "dayjs";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import AlertMessage from "Components/UI/AlertMessage";
import TimelogTable from "./timelog/TimelogTable";
import { useUpdateTimeLogBulkMutation } from "AppQuries/attendance/time-log-bulk";
import { TimelogColumnMap } from "./import/TimelogColumnMap";
const { RangePicker } = DatePicker;
import { format, parseISO, parse, isValid } from "date-fns";
import moment from "moment";
import { encrypt } from "core/Operations/cryptHelper";

const excelEpoch = new Date(Date.UTC(1899, 11, 30));

const parseExcelDateToISO = (value) => {
  if (typeof value === "number") {
    const date = new Date(excelEpoch.getTime() + value * 86400000);
    return isValid(date) ? format(date, "yyyy-MM-dd") : "";
  }

  if (typeof value === "string") {
    let date = parse(value, "dd-MM-yyyy", new Date());
    if (!isValid(date)) {
      date = parseISO(value);
    }
    return isValid(date) ? format(date, "yyyy-MM-dd") : "";
  }

  if (value instanceof Date) {
    return isValid(value) ? format(value, "yyyy-MM-dd") : "";
  }

  return "";
};
const ImportTimelog = () => {
  const userData = useSelector(loggedInUser);
  const companyCode = userData?.companyCode;
  const navigate = useNavigate();
  const validationSchema = Yup.array().of(importTimelogValidationSchema);
  const employeeOptions = useFormattedExcluedEmployeesOptions({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
    departmentCode: userData?.departmentCode,
  });
  const [filterData, setFilterData] = useState({
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
    employeeCode: 0,
  });

  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [employeeData, setEmployeeData] = useState(null);

  const { mutate: importEmployee } = useImportEmployeesMutation();

  const flattenJson = (data) => {
    const result = {};
    const recurse = (cur, prop) => {
      if (Object(cur) !== cur || Array.isArray(cur)) {
        result[prop] = Array.isArray(cur) ? JSON.stringify(cur) : cur;
      } else {
        for (const key in cur) {
          recurse(cur[key], prop ? `${prop}_${key}` : key);
        }
      }
    };
    recurse(data, "");
    return result;
  };

  const handleDownloadSample = () => {
    const flatData = flattenJson(sampleTimelogData);
    const headers = Object.keys(flatData);
    const sample = [headers.map((key) => flatData[key])];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sample]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Sample_Timelog.xlsx");
  };

  const [attendanceData, setAttendanceData] = useState();
  const { mutate: updateBulkAttendance } = useUpdateTimeLogBulkMutation();

  const formatExcelTime = (excelTime) => {
    const totalMinutes = Math.round(excelTime * 24 * 60);
    const hours = Math.floor(totalMinutes / 60)
      .toString()
      .padStart(2, "0");
    const minutes = (totalMinutes % 60).toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const calculateAttendanceValue = (inTime, outTime) => {
    if (!inTime || inTime === "00:00:00" || !outTime || outTime === "00:00:00")
      return 0;

    const startTime = moment(inTime, "HH:mm");
    const endTime = moment(outTime, "HH:mm");
    const totalWorkingHours = moment
      .utc(endTime.diff(startTime))
      .format("HH:mm");

    return totalWorkingHours === "0:0:00" || totalWorkingHours === "0:0"
      ? 0
      : 1;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      setUploadStatus("Processing...");
      setUploadedFileName(file.name);
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      // Convert headers to internal keys
      // const mappedData = jsonData.map((row) => {
      //   const mappedRow = {};
      //   for (let header in row) {
      //     const key = TimelogColumnMap[header];
      //     if (key) {
      //       mappedRow[key] = row[header];
      //     }
      //   }

      //   return mappedRow;
      // });

      // console.log("mappedData", jsonData);

      const finalData = jsonData?.map((updatedRow, index) => {
        return {
          slno: 0,
          companyCode: userData?.companyCode,
          locationCode: userData?.locationCode,
          employeeCode: filterData?.employeeCode,
          attendanceValue: calculateAttendanceValue(
            updatedRow?.In,
            updatedRow?.Out
          ),
          attendanceDate: parseExcelDateToISO(updatedRow?.Date),
          inTime:
            typeof updatedRow?.In === "number"
              ? formatExcelTime(updatedRow?.In)
              : updatedRow?.In || "00:00:00",
          outTime:
            typeof updatedRow?.Out === "number"
              ? formatExcelTime(updatedRow?.Out)
              : updatedRow?.Out || "00:00:00",
          createUser: userData?.userName,
          createDate: getCurrentFormattedDate(),
          modifyUser: userData?.userName,
          modifyDate: getCurrentFormattedDate(),
          scheduleId: 0,
          projectCode: "0",
          shiftId: "",
          remarks: updatedRow?.Remarks || "",
          mode: "MM",
          waitingTime: "00:00:00",
          isApproved: false,
          oT1: 0,
          oT2: 0,
          wtrot: "00:00:00",
          extraCharge: 0,
          approvedDate: "",
          approvedBy: "",
          normalHours: 0,
          haveSplit: false,
          haveShift: false,
          wtnhEdit: false,
          supplierCompany: "",
          service: updatedRow?.Service || "",
          isReviewed: false,
          reviewDate: "",
          reviewBy: "",
          totalWorkingHours: 0,
        };
      });
      console.log(finalData);
      validationSchema
        .validate([finalData])
        .then(() => {
          setUploadStatus("File processed successfully!");
          setAttendanceData(finalData);
        })
        .catch((err) => {
          console.error("Validation error:", err);
          setUploadStatus("Validation error: " + err.message);
        });
    };

    reader.readAsArrayBuffer(file);
  };

  // Function to remove the uploaded file
  const handleRemoveFile = () => {
    setUploadedFileName("");
    setEmployeeData(null);
    setUploadStatus("");
  };
  const importTimelogData = () => {
    updateBulkAttendance(attendanceData, {
      onSuccess: (data) => {
        if (data[0].response === true) {
          toast.success("Time log updated.");
          navigate(
            `${all_routes.attendance}${
              all_routes.time_log
            }?employeeCode=${encrypt(
              filterData?.employeeCode
            )}&fromDate=${encrypt(filterData?.fromDate)}&toDate=${encrypt(
              filterData?.toDate
            )}`
          );
        } else {
          toast.warning(data[0].errorMessage);
        }
      },

      onError: (error) => {
        toast.warning(error.message || "Something went wrong.");
      },
    });
  };

  const updateFilterData = (key, value) => {
    setFilterData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const columns = useMemo(
    () => [
      {
        title: "Date",
        dataIndex: "attendanceDate",
        fixed: "left",
        render: (text, record) => (
          <>
            <div style={{ width: "75px" }}>
              {format(new Date(text), "dd-MM-yyyy")}
            </div>
          </>
        ),
      },
      {
        title: "Day",
        dataIndex: "attendanceDate",
        render: (text, record) => (
          <>
            <div>{format(new Date(record.attendanceDate), "EEE")}</div>
          </>
        ),
      },
      {
        title: "In",
        dataIndex: "inTime",
        // render: (text, record) => (
        //   <InTimePicker
        //     record={record}
        //     handleTimeChange={handleTimeChange}
        //     name="inTime"
        //   />
        // ),
      },
      {
        title: "Out",
        dataIndex: "outTime",
        // render: (text, record) => (
        //   <InTimePicker
        //     record={record}
        //     handleTimeChange={handleTimeChange}
        //     name="outTime"
        //   />
        // ),
      },
      {
        title: "Attendance Value",
        dataIndex: "attendanceValue",
      },
      // {
      //   title: "NH",
      //   dataIndex: "normalWorkingHours",
      //   render: (text, record) => Number(text).toFixed(2),
      //   // render: (text, record) => (
      //   //   <input
      //   //     {...register(`attendance[${record.id}].normalWorkingHours`)}
      //   //     name={`attendance[${record.id}].normalWorkingHours`}
      //   //     type="text"
      //   //     className={`form-control form-control-time-width`}
      //   //     value={watch(`attendance[${record.id}].normalWorkingHours`) || ""}
      //   //     readOnly={true}
      //   //   />
      //   // ),
      // },
      // {
      //   title: "OT1",
      //   dataIndex: "oT1",
      //   // render: (text, record) => (
      //   //   <input
      //   //     {...register(`attendance[${record.id}].oT1`)}
      //   //     name={`attendance[${record.id}].oT1`}
      //   //     type="text"
      //   //     className={`form-control form-control-time-width`}
      //   //     value={watch(`attendance[${record.id}].oT1`) || ""}
      //   //     readOnly={true}
      //   //   />
      //   // ),
      // },
      // {
      //   title: "OT2",
      //   dataIndex: "oT2",
      //   // render: (text, record) => (
      //   //   <input
      //   //     {...register(`attendance[${record.id}].oT2`)}
      //   //     name={`attendance[${record.id}].oT2`}
      //   //     type="text"
      //   //     className={`form-control form-control-time-width`}
      //   //     value={watch(`attendance[${record.id}].oT2`) || ""}
      //   //     readOnly={true}
      //   //   />
      //   // ),
      // },
      // {
      //   title: "TH",
      //   dataIndex: "totalWorkingHours",
      //   render: (text, record) => Number(text).toFixed(2),
      //   // render: (text, record) => (
      //   //   <input
      //   //     {...register(`attendance[${record.id}].totalWorkingHours`)}
      //   //     name={`attendance[${record.id}].totalWorkingHours`}
      //   //     type="text"
      //   //     className={`form-control form-control-time-width`}
      //   //     value={watch(`attendance[${record.id}].totalWorkingHours`) || ""}
      //   //     readOnly={true}
      //   //   />
      //   // ),
      // },
      {
        title: "Remarks",
        dataIndex: "remarks",
        // render: (text, record) => (
        //   <input
        //     {...register(`attendance[${record.id}].remarks`)}
        //     name={`attendance[${record.id}].remarks`}
        //     type="text"
        //     className={`form-control`}
        //     value={watch(`attendance[${record.id}].remarks`) || ""}
        //     style={{ width: "100px" }}
        //     onBlur={() => handleUpdateAttendance(record.id)}
        //     readOnly
        //   />
        // ),
      },
      // {
      //   title: "Action",
      //   render: (text, record) => (
      //     <div className="d-flex justify-content-center">
      //       {/* {(watch(`attendance[${record.id}].inTime`) === "00:00:00" ||
      //           watch(`attendance[${record.id}].inTime`) === "00:00") &&
      //         (watch(`attendance[${record.id}].outTime`) === "00:00:00" ||
      //           watch(`attendance[${record.id}].outTime`) === "00:00") ? (
      //           <Check className="me-2" />
      //         ) : ( */}
      //       <button
      //         type="button"
      //         className="btn btn-sm"
      //         onClick={() => handleShow(record.id, record.employeeName)}
      //         disabled={
      //           watch(`attendance[${record.id}].isApproved`) ||
      //           watch(`attendance[${record.id}].isReviewed`)
      //         }
      //       >
      //         <Edit />
      //       </button>
      //       {/* )} */}
      //     </div>
      //   ),
      // },
      // {
      //   title: "Shift",
      //   dataIndex: "shiftName",
      //   render: (text, record) => (
      //     <ShiftController
      //       handleUpdateAttendance={handleUpdateAttendance}
      //       setTotalWorkingHours={setTotalWorkingHours}
      //       shifts={shifts}
      //       shiftOptions={shiftOptions}
      //       id={record.id}
      //     />
      //   ),
      //   width: "160px",
      // },
      // {
      //   title: "Project",
      //   dataIndex: "projectName",
      //   render: (text, record) => (
      //     <ProjectController
      //       handleUpdateAttendance={handleUpdateAttendance}
      //       id={record.id}
      //       projectsOptions={projectsOptions}
      //     />
      //   ),
      //   width: "160px",
      // },
      // {
      //   title: "Status",
      //   dataIndex: "isApproved",
      //   render: (text, record) => (
      //     <Input
      //       name={`attendance[${record.id}].isApproved`}
      //       type="commonSelect"
      //       className={`form-control select-option-height`}
      //       value={watch(`attendance[${record.id}].isApproved`)}
      //       optionData={isApprovedOptions}
      //       onSelect={(e) => {
      //         setValue(`attendance[${record.id}].isApproved`, e);
      //         setValue(
      //           `attendance[${record.id}].approvedBy`,
      //           watch("userName")
      //         );
      //         setValue(
      //           `attendance[${record.id}].approvedDate`,
      //           format(new Date()),
      //           "yyyy-MM-dd"
      //         );
      //         // setValue(`attendance[${record.id}].isApproved`, e.label);
      //         handleUpdateAttendance(record.id);
      //       }}
      //       style={{ width: "150px" }}
      //       disabled={watch(`attendance[${record.id}].isApproved`)}
      //     />
      //   ),
      //   width: "160px",
      // },
      // {
      //   title: "Approved By",
      //   dataIndex: "approvedBy",
      //   width: "100px",
      // },
      // {
      //   title: "Approved Date",
      //   dataIndex: "approvedDate",
      //   width: "100px",
      //   render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
      // },
      // {
      //   title: "EC(2x)",
      //   dataIndex: "extraCharge",
      //   // render: (text, record) => (
      //   //   <input
      //   //     {...register(`attendance[${record.id}].extraCharge`)}
      //   //     name={`attendance[${record.id}].extraCharge`}
      //   //     type="text"
      //   //     className={`form-control`}
      //   //     value={watch(`attendance[${record.id}].extraCharge`) || ""}
      //   //     readOnly={true}
      //   //     style={{ width: "100px" }}
      //   //   />
      //   // ),
      // },
      // {
      //   title: "Late",
      //   dataIndex: "late",
      //   // render: (text, record) => (
      //   //   <input
      //   //     name={`attendance[${record.id}].late`}
      //   //     type="text"
      //   //     className={`form-control`}
      //   //     defaultValue={watch(`attendance[${record.id}].late`)}
      //   //     readOnly={true}
      //   //     style={{ width: "100px" }}
      //   //   />
      //   // ),
      // },
      // {
      //   title: "DW",
      //   dataIndex: "dayworking",
      // },
      // {
      //   title: "WT",
      //   dataIndex: "waitingTime",
      //   render: (text, record) => (
      //     <InTimePicker
      //       record={record}
      //       handleTimeChange={handleTimeChange}
      //       name="waitingTime"
      //     />
      //   ),
      // },
      // {
      //   title: "WTROT",
      //   dataIndex: "wtrot",
      //   render: (text, record) => (
      //     <InTimePicker
      //       record={record}
      //       handleTimeChange={handleTimeChange}
      //       name="wtrot"
      //     />
      //   ),
      // },
    ],
    [attendanceData]
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Import Timelog</h4>
              <h6>Add Employees Timelog from excel sheet</h6>
            </div>
          </div>

          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.attendance}${all_routes.time_log}`}
                className="btn btn-secondary"
              >
                <ArrowLeft className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>
        <div className="card border-0">
          <div className="card-body">
            <div className="row form-row">
              <div className="col-md-3">
                <div className="form-floating">
                  <Select
                    placeholder="Select Employees"
                    className={`form-control`}
                    options={employeeOptions}
                    onChange={(selectedOptions) => {
                      console.log(selectedOptions);
                      updateFilterData("employeeCode", selectedOptions);
                    }}
                    showSearch
                    allowClear
                    updateFilterData={() => {
                      updateFilterData("employeeCode", 0);
                    }}
                    style={{ width: "100%", height: "auto" }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  <label className="form-label">Employee</label>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-floating">
                  <RangePicker
                    className="form-control"
                    style={{ display: "flex" }}
                    onChange={(date, dateFormat) => {
                      updateFilterData("fromDate", dateFormat[0]);
                      updateFilterData("toDate", dateFormat[1]);
                    }}
                    defaultValue={[
                      dayjs(filterData.fromDate, "YYYY-MM-DD"),
                      dayjs(filterData.toDate, "YYYY-MM-DD"),
                    ]}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    //   disabledDate={(current) => {
                    //     return current && current < dayjs().startOf("day");
                    //   }}
                  />
                  <label className="form-label">From - To Date </label>
                </div>
              </div>
              {filterData?.employeeCode ? (
                <div className="col-lg-12">
                  <div className="modal-footer-btn download-file mb-3">
                    <button
                      onClick={handleDownloadSample}
                      // onClick={() => generateExcel({ optionData })}
                      className="btn btn-submit"
                      type="button"
                    >
                      Download Sample File
                    </button>
                    &nbsp;
                    <button
                      // onClick={handleDownloadSample}
                      onClick={importTimelogData}
                      className="btn btn-submit"
                      type="button"
                      disabled={!uploadedFileName || employeeData?.length === 0}
                    >
                      Import
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
              {filterData?.employeeCode ? (
                <>
                  <div className="col-lg-12">
                    <div className="input-blocks image-upload-down mb-10">
                      <label> Upload Excel File</label>
                      <div className="image-upload download">
                        {!uploadedFileName ? (
                          <>
                            <input
                              type="file"
                              accept=".xlsx, .xls"
                              onChange={handleFileUpload}
                            />
                            <div className="image-uploads">
                              <ImageWithBasePath
                                src="assets/img/download-img.png"
                                alt="img"
                              />
                              <h4>
                                Drag and drop a <span>file to upload</span>
                              </h4>
                            </div>
                          </>
                        ) : (
                          <div className="uploaded-file-info">
                            <div className="image-uploads">
                              <p>Uploaded File: {uploadedFileName}</p>
                              <button
                                className="btn btn-secondary btn-sm"
                                onClick={handleRemoveFile}
                              >
                                Remove File
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12" style={{ marginTop: "75px" }}>
                    {uploadStatus && (
                      <>
                        <div
                          className={`alert ${
                            uploadStatus.includes("Successfully")
                              ? "alert-success"
                              : "alert-info"
                          } mt-3`}
                        >
                          {uploadStatus}
                        </div>
                        <div className="table-responsive">
                          <Table
                            columns={columns}
                            dataSource={attendanceData}
                            pagination={false}
                            // rowKey="id"
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="col-lg-12">
                    <div className="table-responsive"></div>
                  </div>
                </>
              ) : (
                <div className="row">
                  <hr />
                  <div className="col-md-12">
                    <AlertMessage
                      message="Please select employee"
                      type="danger"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportTimelog;
